import { render } from "./ContactsComponent.vue?vue&type=template&id=16f3048d&scoped=true"
const script = {}

import "./ContactsComponent.vue?vue&type=style&index=0&id=16f3048d&scoped=true&lang=css"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f3048d"]])

export default __exports__